// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2JM4Z","validationTips":"StatementDescriptor_validationTips__3O9ZT"};